import { JsonLogicOperator } from '@atlassian/jira-polaris-domain-field/src/decoration/constants.tsx';
import jsonLogic from '@atlassian/jira-polaris-lib-json-logic/src/index.tsx';
import type { RulesLogic } from '@atlassian/jira-polaris-domain-field/src/decoration/types.tsx';

const DATE_COMING_SOON_LOGIC_PATTERN: RulesLogic = {
	[JsonLogicOperator.LT]: ['@', { var: 'daysUntilDueDate' }, '@'],
};

/**
 * Checks if the logic is a date coming soon option
 *
 * @returns true if the logic is a date coming soon option, false otherwise
 */
export const isDateComingSoonOption = (logic: RulesLogic): boolean => {
	return jsonLogic.rule_like(logic, DATE_COMING_SOON_LOGIC_PATTERN);
};

const DATE_OVERDUE_LOGIC_PATTERN: RulesLogic = {
	[JsonLogicOperator.LT]: [{ var: 'daysUntilDueDate' }, '@'],
};

/**
 * Checks if the logic is a date overdue option
 *
 * @returns true if the logic is a date overdue option, false otherwise
 */
export const isDateOverdueOption = (logic: RulesLogic): boolean => {
	return jsonLogic.rule_like(logic, DATE_OVERDUE_LOGIC_PATTERN);
};
